import io from 'socket.io-client'
import { safeJsonParse } from './utils/jsonUtils'

const rawToken = localStorage.getItem('accessToken')
const token = safeJsonParse(rawToken) ?? ''

const socket = io(process.env.REACT_APP_BASE_URL, {
  auth: { token },
  transports: ['websocket'],
})

export default socket
